import { Divider } from 'antd';
import { useNavigate } from 'react-router-dom';
import useMount from 'common/hooks/useMount';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Button, FormsList, SearchBox } from 'common/components';
import {
  selectFormsListItems,
  selectFormsListPagination,
  selectIsFormsListLoading,
  setFormsListPageNumberAction,
  setFormsListPageSizeAction,
  setFormsListSearchQueryAction,
} from '../forms/ducks';

export default function AdminFormsFeature() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const transactions = useSelector(selectFormsListItems);
  const pagination = useSelector(selectFormsListPagination);
  const loading = useSelector(selectIsFormsListLoading);

  useMount(() => {
    dispatch(setFormsListSearchQueryAction(''));
  });

  function handleShowDetails(id: string) {
    navigate(`/form/${id}`);
  }

  function handleSearchSubmit(query: string) {
    dispatch(setFormsListSearchQueryAction(query));
  }

  function handlePageChange(page: number) {
    dispatch(setFormsListPageNumberAction(page));
  }

  function handlePageSizeChange(current: number, size: number) {
    dispatch(setFormsListPageSizeAction(size));
  }

  return (
    <>
      <div style={{ margin: '30px 0' }}>
        <SearchBox
          onSearchClicked={handleSearchSubmit}
          buttonText={t('formsManagement.search')}
          placeholder={t('formsManagement.searchPlaceholder')}
        />
      </div>
      <Divider />
      <FormsList
        displayOwner
        items={transactions}
        totalItems={pagination.total}
        currentPage={pagination.currentPage}
        pageSize={pagination.pageSize}
        loading={loading}
        renderActions={(item) => [
          <Button
            key="details"
            onClick={() => {
              handleShowDetails(item.id);
            }}
            type="primary"
          >
            {t('formsManagement.details')}
          </Button>,
        ]}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </>
  );
}
